import { ShiftFiltersForm, TimecardFiltersForm } from "../../types/forms";

export interface FiltersState
{
    shifts: ShiftFiltersForm,
    timecards: TimecardFiltersForm
}

export const FILTERS_FEATURE_KEY = 'filters';
